<template>
  <div>
    <div
      v-if="answer && answer.description"
      class="mb-6 flex items-center gap-2 rounded-[8px] p-4"
      :class="[answer.is_right ? 'bg-correct/10' : 'bg-ruby-red-100/10']"
    >
      <SvgIcon
        :name="answer.is_right ? 'success-n' : 'info-n'"
        class="size-6"
      />
      <span>{{ answer.description }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  answer: {
    type: Object,
    default: () => ({}),
  },
});
</script>
